import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableCodePipe'
})
export class TableCodePipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }
    let width = 4;
    let numberOutput = Math.abs(Number(value));
    let length = value.toString().length;
    let zero = '0';

    if (width <= length) {
      if (Number(value) < 0) {
        return '-' + numberOutput.toString();
      } else {
        return numberOutput.toString();
      }
    } else {
      if (Number(value) < 0) {
        return '-' + zero.repeat(width - length) + numberOutput.toString();
      } else {
        return zero.repeat(width - length) + numberOutput.toString();
      }
    }
  }
}
